import brandGuidelinesAgent from 'common/src/modules/brandGuidelines/copilot/brandGuidelinesAgent/brandGuidelinesAgent';
import {FeatureFlagKey} from 'common/src/modules/featureFlags/featureFlags.types';
import isFlagEnabled from 'common/src/modules/featureFlags/utils/isFlagEnabled';
import brandGuidelinesSkill from 'common/src/modules/shared/copilot/skills/definitions/brandGuidelinesSkill';
import {registerSkill} from 'common/src/modules/shared/copilot/skills/skillRegistry';
import {CLStore} from 'common/src/redux/store';
import {copilot} from '@cl/shared';

function initializeBrandGuidelinesAgents(store: CLStore) {
  if (isFlagEnabled(FeatureFlagKey.EnableCopilotBrandGuidelinesAgent)) {
    if (!isFlagEnabled(FeatureFlagKey.EnableCopilotSkills)) {
      copilot.registerAgent(brandGuidelinesAgent(store));
    }

    registerSkill(brandGuidelinesSkill(store));
  }
}

export default initializeBrandGuidelinesAgents;
